import React from 'react';
import { withRouter } from 'react-router-dom';
import ConsentDialog from '../../../../common/ConsentDialog';
import { Button, BUTTON_VARIANTS, Loader, Link, LINK_ICON_POSITIONS, IconOpenInNew, IconCheckCircle, StatusIndicator } from 'cdk-radial';
import './styles/appTerms.scss';
import { connect } from 'react-redux';
import {
  createSolutionTermsConsent,
  getConsets,
  saveConsentToMetaDataTable,
  updateConsentSuccess,
  getUserDetails
} from '../../../../../redux/connectedComponent/appTerms/appTerms.slice';
import { checkAppTermsSigned } from '../../../../../redux/connectedComponent/selectedLocations/selectedLocations.slice';
import ConsentAccordion from './ConsentAccordion';

import { sendAmplitudeData } from '../../../../../utils/amplitude';
import { AMPLITUDE_EVENTS,AMPLITUDE_PROPERTIES } from '../../../../../constants/amplitudeConstants';

const COLOR_STROKE = '#006CFA';
const DARK_GREEN = 'rgb(9, 173, 0)';
const LIGHT_GREEN = 'rgb(205, 240, 204)';
const DARK_GRAY = 'rgb(169, 169, 169)';
const LIGHT_GRAY = 'rgb(211, 211, 211)';

const SOLUTION_TnC = 'solution_tnc';
const COMPLETED = 'completed';
const DEALER_PORTAL = 'dealerportal';
const SUBSCRIPTION = 'subscription';

const LOADER_STYLE = {
  stroke: COLOR_STROKE,
  margin: '0px 70px'
};

class AppTerms extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openConsentDialog: false,
      isAppTermsAccepted: true,
      isDeterminingAppTermsAccepted: true,
      solutionId:
        this.props.match &&
        this.props.match.params &&
        this.props.match.params.solutionId,
      selectedPlanId:
        this.props.match &&
        this.props.match.params &&
        this.props.match.params.selectedPlanId,
      loading: false,
      consentDetails: null
    };
    this.onReviewTerms = this.onReviewTerms.bind(this);
  }

  onReviewTerms() {
    this.setState({
      openConsentDialog: true,
      loading : true
    });
  }

  static getDerivedStateFromProps(nextProps) {
    const consentInfo = nextProps.consentInfo;
    const appConsentDetails = nextProps.appConsentDetails;
    //wait for consents info for all the locations before determining

    let appTermsAccepted;
    for (var key in consentInfo) {
      if(!consentInfo[key].hasOwnProperty('appTermsAccepted')) return;
      if (key && !consentInfo[key].appTermsAccepted) {
        return {
          isAppTermsAccepted: false
        };
      } else {
        appTermsAccepted = true;
      }
    }

    return {
      consentDetails: appConsentDetails ,
      isAppTermsAccepted: appTermsAccepted
    };
  }

  consentForSolutionTerms = async consentData => {
    const solutionInfo = this.props.solutionInfo;
    const solutionInfoOverview =this.props.solutionInfo && this.props.solutionInfo.overview;

    let navigatedFromSubscriptionManagement = this.props.navigatedFromSubscriptionManagement;

    const solutionId = navigatedFromSubscriptionManagement ? this.props.solutionId : this.state.solutionId;
    const selectedPlanId = navigatedFromSubscriptionManagement ? this.props.selectedPlanId : this.state.selectedPlanId;

    this.setState({ openConsentDialog: false });

    const listingVersion = solutionInfo.listingVersion
      ? solutionInfo.listingVersion
      : '1';

    let consentInfo = this.props.consentInfo;
    var entityList = [],
      cmfNumberList = [],
      locationList = [];

    for (const entityId in consentInfo) {
      if (
        entityId &&
        consentInfo[entityId].appTermsAccepted === false
      ) {
        entityList.push({entityId, cmfNumber: consentInfo[entityId].cmfNumber});
        cmfNumberList.push(consentInfo[entityId].cmfNumber);
        locationList.push(consentInfo[entityId].location);
      }
    }

    const firstName = this.props.userInfo?.firstName;
    const lastName = this.props.userInfo?.lastName;
    const email = this.props.userEmail;
    const consentPayload = {
      email: email,
      firstName: firstName,
      lastName: lastName,
      entityList: entityList,
      documentLink:
        solutionInfoOverview && solutionInfoOverview.termsAndConditionsUrl,
      solutionId: solutionId,
      listingVersion: listingVersion,
      solutionVersion:
        solutionInfoOverview && solutionInfoOverview.version
          ? solutionInfoOverview.version
          : null,
      reasonForRejection: consentData.rejectionReason
        ? consentData.rejectionReason
        : null,

      status: consentData.consentStatus
        ? consentData.consentStatus.toLowerCase()
        : null,
      consentType: SOLUTION_TnC,
      apiProviderId: 'NA',
      subscriptionStatus: COMPLETED,
      consentedSource: DEALER_PORTAL,
      signedTermsAndConditions: consentData.signedTermsAndConditions
        ? consentData.signedTermsAndConditions
        : null
    };

    const token = this.props.token;

    let loggedInUserEmail = this.props.userInfo?.sub;
    let businessRoleData = await this.props.getUserDetails({
      loggedInUserEmail,
      firstName,
      lastName,
      token
    });
    if (businessRoleData && businessRoleData.payload && businessRoleData.payload.data) {
      businessRoleData.payload.data.dealershipName = Object.values(consentInfo).map(ci => ci.location).join();
      consentPayload.businessRoleData = businessRoleData.payload.data;
    }

    await this.props.createSolutionTermsConsent({
      consentPayload,
      solutionId,
      listingVersion,
      token
    });

    entityList &&
      entityList.map(async (item, index) => {
        let entityId = item.entityId;
        await this.props.getConsets({
          solutionId,
          entityId,
          token
        });

        let consent =
          this.props.appTerms &&
          this.props.appTerms &&
          this.props.appTerms.savedConsent[entityId];

        let payload = {
          firstName,
          lastName,
          email,
          activateOnly: this.props.activateOnly,
          entitycmfNumber: item.cmfNumber,
          consentId: consent && consent.consentId,
          consentType: SUBSCRIPTION,
          entityId: entityId,
          requested_status: '',
          solutionId: solutionId,
          selectedPlanId: solutionInfo.activateOnly === false ? selectedPlanId : ''
        };

        await this.props.saveConsentToMetaDataTable({
          payload,
          token
        });

        let location = locationList[index];
        await this.props.checkAppTermsSigned({
          solutionId,
          entityId,
          location,
          selectedLocationCMFNumber: item.cmfNumber,
          token
        });
      });
      this.setState({
        loading : false
      })

      const { selectedLocationsWithCMFNumber } = this.props;

      sendAmplitudeData(AMPLITUDE_EVENTS.ACCEPTED_APP_TERMS, {
        [AMPLITUDE_PROPERTIES.APP_NAME]:  solutionInfo?.overview?.name,
        [AMPLITUDE_PROPERTIES.APP_ID]:  solutionInfo?.id,
        [AMPLITUDE_PROPERTIES.LOCATION_COUNT]: selectedLocationsWithCMFNumber?.length,
        [AMPLITUDE_PROPERTIES.LOCATIONS]: selectedLocationsWithCMFNumber?.map(
          (loc) => ({
            [AMPLITUDE_PROPERTIES.ORG_ID]: loc?.entityId,
            [AMPLITUDE_PROPERTIES.ORG_NAME]: loc?.location,
            [AMPLITUDE_PROPERTIES.ORG_CMF]: loc?.cmfNumber,
          })
        ),
      });
  };

  openMultipleConsents=()=>{

    let {
      consentInfo
    } = this.props
    let consents=[]
    for (let key in consentInfo) {
      if (key && consentInfo[key].appTermsAccepted) {
        let consent = consentInfo[key].appTermsAccepted;
        if (consent.signedTermsAndConditions) {
          consents.push(consent.signedTermsAndConditions);
        } else if (consent.documentLink) {
          consents.push(consent.documentLink);
          break;
        }
      }
    }
    for(const url of consents)
    {
      window.open(url,'_blank')
    }
  }

  componentDidUpdate(){

    if(this.props.createConsentSuccess)
    {
      this.props.updateConsentSuccess()
    }
  }

  render() {
    return (
      this.props.activateOnly === false ?
      <div className={this.props.doesAppRequireDataRights  ? "app-terms-container" : "no-datarights-app-terms-container"}>
        <div className="app-terms-header">
          <div className="app-terms-header-title">App terms</div>
          <div className="app-terms-header-description">
            Review and accept the following terms related to this app.
          </div>
        </div>
        <div className="app-terms-body">
          <div>
          {this.state.isAppTermsAccepted && !(
              this.props.isCheckAppTermsSignedPending ||
              this.props.appTerms.isCreateSolutionTermsConsentPending ||
              this.props.appTerms.isGetConsetsPending ||
              this.props.appTerms.isSaveConsentToMetaDataTablePending)?
          <div className="app-terms-body-app-publisher">
          <span className="addendums-body-clickable-app-name" onClick={this.openMultipleConsents}>
            {this.props.appName}
              <Link
                icon={<IconOpenInNew height="14" width="14" />}
                iconPosition={LINK_ICON_POSITIONS.LEADING}
              />
              </span>
              view agreement
          </div>
          :
            <div className="app-terms-body-app-name">{this.props.appName}</div>}
            <div className="app-terms-body-app-publisher">
             By: {this.props.publisherName}
            </div>
          </div>
          <div className='app-terms-body-review-terms-container'>
            <div className="app-terms-body-review-terms">
              {
              this.props.checkAppTermsErroredEntityIds?.length  ?
                <StatusIndicator
                  backgroundColor={LIGHT_GRAY}
                  borderColor={DARK_GRAY}
                  iconColor={DARK_GREEN}
                  label="Failed to load data"
                  variant="custom"
                />
               :
              this.props.isCheckAppTermsSignedPending ||
              this.props.appTerms.isCreateSolutionTermsConsentPending ||
              this.props.appTerms.isGetConsetsPending ||
              this.props.appTerms.isSaveConsentToMetaDataTablePending ||
              this.state.loading ? (
                <Loader style={LOADER_STYLE} />
              ) : this.state.isAppTermsAccepted ? (
                <div className='accepted-terms'>
                  <div className='terms-status-tag'>
                    <StatusIndicator
                      backgroundColor={LIGHT_GREEN}
                      borderColor={DARK_GREEN}
                      icon={<IconCheckCircle />}
                      iconColor={DARK_GREEN}
                      label="Terms accepted"
                      variant="custom"
                    />
                  </div>
                </div>
              ) : (
                <Button
                  data-testid="review-terms-button"
                  backgroundAppearance="light"
                  customTagElement=""
                  dataTestId="button"
                  hideText={false}
                  iconClassName=""
                  iconColor="primary"
                  iconSize={28}
                  isDisabled={this.props.doesAppRequireDataRights ? (this.props.isCheckDataRightsSignedPending ? true : !this.props.isDataRightsAccepted ) : false}
                  isLoading={false}
                  loaderText="Loading..."
                  onClick={this.onReviewTerms}
                  onKeyDown={function noRefCheck() {}}
                  preserveClickableArea={false}
                  size="standard"
                  icon={<IconOpenInNew />}
                  text="Review Terms"
                  type=""
                  variant={BUTTON_VARIANTS.SECONDARY}
                />
              )}
            </div>
          </div>
        </div>
        <div>
        {
            this.state.isAppTermsAccepted
            ? <div className='consent-details-tag'>
            {
              this.state.consentDetails && this.state.consentDetails.length
                ? <ConsentAccordion data={this.state.consentDetails}/>
              : null
            }

          </div> : null
        }
        </div>
        {this.state.openConsentDialog && (
          <ConsentDialog
            type={'solution'}
            consentType={this.props.appTermsType}
            open={true}
            title={this.props.appName}
            onAccept={consentData => this.consentForSolutionTerms(consentData)}
            onClose={() => {
              this.setState({
                openConsentDialog: false,
                loading: false
              });
            }}
            docUrl={this.props.appTermsSignedS3Url}
            fileName={this.props.appTermsAndConditionsUrl
              ? this.props.appTermsAndConditionsUrl.slice(this.props.appTermsAndConditionsUrl.lastIndexOf('/') + 1)
              : 'AppTerms.pdf'}
            preLoadedAppTerms={this.props.preLoadedAppTerms}
            signatureCoordinates={this.props.appTermsSignatureCoordinates}
            userInfo={{
              firstName: this.props.userInfo && this.props.userInfo.firstName,
              lastName: this.props.userInfo && this.props.userInfo.lastName
            }}
            email={this.props.userEmail}
            token={this.props.token}
          />
        )}
      </div> : null
    );
  }
}

const mapStateToProps = state => ({
  appName:
    state &&
    state.solutionInfoSlice &&
    state.solutionInfoSlice.solutionInfo.overview &&
    state.solutionInfoSlice.solutionInfo.overview.name,
  publisherName:
    state &&
    state.solutionInfoSlice &&
    state.solutionInfoSlice.solutionInfo.overview &&
    state.solutionInfoSlice.solutionInfo.overview.publisherName,
  appTermsAndConditionsUrl:
    state &&
    state.solutionInfoSlice &&
    state.solutionInfoSlice.solutionInfo &&
    state.solutionInfoSlice.solutionInfo.overview &&
    state.solutionInfoSlice.solutionInfo.overview.termsAndConditionsUrl,
  preLoadedAppTerms:
    state &&
    state.solutionInfoSlice &&
    state.solutionInfoSlice.preLoadedAppTerms,
  appTermsSignatureCoordinates:
    state &&
    state.solutionInfoSlice &&
    state.solutionInfoSlice.appTermsSignatureCoordinates,
  appTermsType:
    state && state.solutionInfoSlice && state.solutionInfoSlice.appTermsType,
  activateOnly:
    state && state.solutionInfoSlice && state.solutionInfoSlice.solutionInfo.activateOnly,
  isCheckAppTermsSignedPending:
    state &&
    state.selectLocationsSlice &&
    state.selectLocationsSlice.isCheckAppTermsSignedPending,
  isCheckAppTermsSignedErrored:
    state &&
    state.selectLocationsSlice &&
    state.selectLocationsSlice.isCheckAppTermsSignedErrored,
  checkAppTermsErroredEntityIds:
    state &&
    state.selectLocationsSlice &&
    state.selectLocationsSlice.checkAppTermsErroredEntityIds,
  consentInfo:
    state &&
    state.selectLocationsSlice &&
    state.selectLocationsSlice.consentInfo,
  appConsentDetails:
    state &&
    state.selectLocationsSlice &&
    state.selectLocationsSlice.appConsentDetails,
  userInfo:
    state && state.loginDetailsSlice && state.loginDetailsSlice.decodedToken,
  userEmail: state && state.loginDetailsSlice && state.loginDetailsSlice.userEmail,
  token:
    state &&
    state.loginDetailsSlice &&
    state.loginDetailsSlice.authenticationToken,
  solutionInfo:
    state && state.solutionInfoSlice && state.solutionInfoSlice.solutionInfo,
  appTerms: state && state.appTermsSlice,
  selectedLocations:
    state &&
    state.selectLocationsSlice &&
    state.selectLocationsSlice.selectedLocations,
  createConsentSuccess:state &&
    state.appTermsSlice &&
    state.appTermsSlice.createConsentSuccess,
  doesAppRequireDataRights:
    state &&
    state.solutionInfoSlice &&
    state.solutionInfoSlice.captureDataRights,
  isDataRightsAccepted :
    state &&
    state.selectLocationsSlice &&
    state.selectLocationsSlice.isDataRightsAccepted,
  isCheckDataRightsSignedPending :
    state &&
    state.selectLocationsSlice &&
    state.selectLocationsSlice.isCheckDataRightsSignedPending,
  appTermsSignedS3Url:
    state &&
    state.solutionInfoSlice &&
    state.solutionInfoSlice.appTermsSignedS3Url,
  selectedLocationsWithCMFNumber: state?.selectLocationsSlice?.selectedLocationsWithCMFNumber
});

const mapDispatchToProps = {
  createSolutionTermsConsent,
  getConsets,
  saveConsentToMetaDataTable,
  checkAppTermsSigned,
  updateConsentSuccess,
  getUserDetails
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AppTerms)
);
